import { useRef, useState, useImperativeHandle } from 'react';

export default function useSectionHighlightRef(ref) {
    const sectionRef = useRef();
    const [highlightField, setHighlightField] = useState('');

    useImperativeHandle(ref, () => ({
        scrollToAndHighlightField(fieldName) {
            sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setHighlightField(fieldName);
            setTimeout(() => setHighlightField(''), 2000);
        }
    }));

    return { sectionRef, highlightField };
}
